export enum EstadoCliente {
    Habilitado = 0,
    Bloqueado = 1
}